import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

class OrderService {
  getAuthToken() {
    const token = localStorage.getItem('adminToken');
    return token ? `Bearer ${token}` : '';
  }

  async getAllOrders(params = {}) {
    try {
      const response = await axios.get(`${API_URL}/orders/admin/all`, {
        params,
        headers: {
          Authorization: this.getAuthToken()
        }
      });
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  async getOrderDetails(orderId) {
    try {
      const response = await axios.get(`${API_URL}/orders/${orderId}`, {
        headers: {
          Authorization: this.getAuthToken()
        }
      });
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  async updateOrderStatus(orderId, data) {
    try {
      const response = await axios.put(`${API_URL}/orders/admin/${orderId}/status`, data, {
        headers: {
          Authorization: this.getAuthToken()
        }
      });
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  async getOrderStats() {
    try {
      const response = await axios.get(`${API_URL}/orders/admin/stats`, {
        headers: {
          Authorization: this.getAuthToken()
        }
      });
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  async bulkUpdateOrderStatus(orderIds, status) {
    try {
      const response = await axios.put(`${API_URL}/orders/admin/bulk/status`, {
        orderIds,
        status
      }, {
        headers: {
          Authorization: this.getAuthToken()
        }
      });
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  handleError(error) {
    if (error.response) {
      return {
        message: error.response.data.message || 'An error occurred',
        errors: error.response.data.errors || []
      };
    }
    return {
      message: 'Network error. Please check your connection.',
      errors: []
    };
  }
}

export default new OrderService();
